<template>
    <div class="page-container">
        <span>详细数据</span>

    </div>
</template>
<script>

export default {
    name: 'DeviceDetails',
    props: {
        deviceNo: {
            type: String,
            required: true
        },
        deviceId:{
            type: String,
            required: true
        }
    },
    data() {
        return {
          
        }
    },
    watch: {

    },
    methods: {
     getData(){
            let deviceNo=this.deviceNo
            this.$postForm('',deviceNo).then(res => {
                console.log(res);
                if(res.result != null){
                 
                }else{
                  this.$message({
                    message:'暂无详细信息',
                    type:'warning'
                  })
                }
               
            });
        },
    },
    mounted() {

    }
}
</script>
<style lang="scss" scoped>

</style>
